import { Link } from '@tanstack/react-router'
import { Container } from '~/components/ui/Container'
import { pageTop } from '~/components/ui/PageHero'
import { PageTitle } from '~/components/ui/PageTitle'

export function NotFound() {
  return (
    <Container width="narrow" className={`${pageTop} pb-24 text-center`}>
      {/* React hoists this into <head>. The CDN answers unknown URLs with the
          shell and a 404 status; this keeps crawlers from indexing them. */}
      <meta name="robots" content="noindex" />
      <PageTitle size="md">Page not found</PageTitle>
      <p className="pt-4 text-fg-muted">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link
        to="/"
        className="inline-block pt-8 text-accent underline hover:text-accent-hover"
      >
        Go home
      </Link>
    </Container>
  )
}
